import React, { Fragment } from 'react'
import { Form, Input, Typography } from 'antd'
import PropTypes from 'prop-types'

const inlineLayout = {
  labelCol: { xs: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, lg: { span: 12 } },
}

const freeFireId = (
  <Typography.Text style={{ fontSize: '18px' }}>
    Insira o ID do FreeFire:
  </Typography.Text>
)

const otherFreeFireId = (
  <Typography.Text style={{ fontSize: '18px' }}>
    Insira o ID do FreeFire (Caso tenha comprado para ID&apos;s diferentes)
  </Typography.Text>
)

export const FreeFire = ({ handleChange, answers }) => {
  return (
    <Fragment>
      <Typography.Title level={4}>
        <span style={{ color: '#d60202' }}>*</span>4. Informe o seu ID no
        Freefire para liberação dos créditos. *Caso tenha comprado mais de 1
        unidade e deseja a liberação para diferentes ID&apos;s especifique
        abaixo em cada caixa. Caso seja para somente um ID não é necessário
        preencher as outras caixas.
      </Typography.Title>
      <Form.Item name='freeFireId' label={freeFireId} {...inlineLayout}>
        <Input
          type='text'
          name='freeFireId'
          value={answers?.freeFireId}
          onChange={handleChange('freeFireId')}
          required
        />
      </Form.Item>
      <Form.Item
        name='otherFreeFire1'
        label={otherFreeFireId}
        {...inlineLayout}
      >
        <Input
          type='text'
          name='otherFreeFire1'
          value={answers?.otherFreeFire1}
          onChange={handleChange('otherFreeFire1')}
        />
      </Form.Item>
      <Form.Item
        name='otherFreeFire2'
        label={otherFreeFireId}
        {...inlineLayout}
      >
        <Input
          type='text'
          name='otherFreeFire2'
          value={answers?.otherFreeFire2}
          onChange={handleChange('otherFreeFire2')}
        />
      </Form.Item>
    </Fragment>
  )
}

FreeFire.propTypes = {
  handleChange: PropTypes.func,
  answers: PropTypes.any,
}
